import React, { useState } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import "./style.css";

const Welcome = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="welcome-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="welcome-content">
              <h2>Hành Trình Mới — Gia Đình Nhỏ Của Hanh & Phương</h2>
              <p>
                Ngày <b>26.02.2026</b> khép lại những năm tháng hẹn hò ngọt ngào để mở ra chương mới mang tên Gia Đình.
                <br />
                Cảm ơn bạn vì đã luôn dõi theo, chúc phúc và yêu thương hai đứa trên mọi nẻo đường! ❤️
              </p>
              <div className="btn">
                <AnchorLink
                  href="#journey"
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  {isHovered ? "Cùng lật mở nhé! 🥰" : "📖 Khám Phá Kệ Sách Kỷ Niệm"}
                </AnchorLink>{" "}
              </div>
              {/* <LocationMap buttonClass={"location-btn"} /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
